import { ProjectType } from 'nekst-api';
import React from 'react';
import { BaseInputProps, Dropdown, Option } from 'ui-builder';
import useFeatureToggleService from 'feature-toggle';

export interface ProjectTypeDropdownProps extends BaseInputProps {
  additionalOptions?: Option<string>[]
}

export function ProjectTypeDropdown(props: ProjectTypeDropdownProps) {
  const featureToggleService = useFeatureToggleService();

  const options = [
    {
      value: ProjectType.LISTING,
      label: 'Listing',
    },
    {
      value: ProjectType.PENDING_BUYER,
      label: 'Pending Buyer',
    },
    {
      value: ProjectType.PENDING_SELLER,
      label: 'Pending Seller',
    },
    {
      value: ProjectType.PENDING_DUAL,
      label: 'Pending Dual',
    },
    ...featureToggleService.isActiveBuyerEnabled() ? [{
      value: ProjectType.ACTIVE_BUYER,
      label: 'Active Buyer',
    }] : [],
    {
      value: ProjectType.OTHER,
      label: 'Other',
    },
    ...props.additionalOptions ? props.additionalOptions : [],
  ]

  /* eslint-disable react/jsx-props-no-spreading */
  return (
    <Dropdown<string>
      {...props}
      options={options}
    />
  );
}
